import { useState } from 'react'
import { useFinance } from '../../context/FinanceContext'
import { useAuth } from '../../context/AuthContext'
import { PAGES } from '../../lib/constants'

const NAV_ITEMS = [
  { page: PAGES.DASHBOARD, label: 'Dashboard' },
  { page: PAGES.INCOME_CAREER, label: 'Income & Career' },
  { page: PAGES.FINANCIAL_HEALTH, label: 'Financial Health' },
  { page: PAGES.LOANS_DEBT, label: 'Loans & Debt' },
  { page: PAGES.LIFE_DECISIONS, label: 'Life Decisions' },
  { page: PAGES.INVESTING_RETIREMENT, label: 'Investing & Retirement' },
  { page: PAGES.SETTINGS, label: 'Settings' },
]

export default function Header() {
  const { state, navigate, toggleTheme } = useFinance()
  const { logout } = useAuth()
  const [mobileOpen, setMobileOpen] = useState(false)

  return (
    <header className="lg:hidden fixed top-0 left-0 right-0 z-30 glass border-b border-card">
      <div className="flex items-center justify-between px-4 h-14">
        <button onClick={() => { navigate(PAGES.DASHBOARD); setMobileOpen(false) }} className="flex items-center gap-2 hover:opacity-80 transition">
          <img src="/app-icon.png" alt="Liquid Finance" className="w-7 h-7 rounded-lg object-cover" />
          <span className="font-bold text-sm text-heading">Liquid Finance</span>
        </button>

        <div className="flex items-center gap-2">
          <button onClick={toggleTheme} className="p-2 rounded-lg bg-hover transition">
            {state.theme === 'dark' ? (
              <svg className="w-4 h-4 text-muted" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z" />
              </svg>
            ) : (
              <svg className="w-4 h-4 text-muted" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z" />
              </svg>
            )}
          </button>
          <button onClick={() => setMobileOpen(!mobileOpen)} className="p-2 rounded-lg bg-hover transition">
            <svg className="w-5 h-5 text-heading" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
              {mobileOpen ? (
                <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
              ) : (
                <path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h16M4 18h16" />
              )}
            </svg>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <nav className="px-4 pb-4 space-y-1 border-t border-card pt-2">
          {NAV_ITEMS.map(({ page, label }) => (
            <button
              key={page}
              onClick={() => { navigate(page); setMobileOpen(false) }}
              className={`w-full text-left px-3 py-2 rounded-lg text-sm font-medium transition ${
                state.page === page
                  ? 'bg-active text-heading'
                  : 'text-muted hover:text-heading bg-hover'
              }`}
            >
              {label}
            </button>
          ))}
          <div className="border-t border-card pt-2 mt-2">
            <button
              onClick={() => { setMobileOpen(false); logout() }}
              className="w-full text-left px-3 py-2 rounded-lg text-sm font-medium text-negative hover:bg-negative/10 transition"
            >
              Sign Out
            </button>
          </div>
        </nav>
      )}
    </header>
  )
}
